// Angular:
import { Component, HostBinding, Input } from '@angular/core';

// Dependencies:
import { notNull } from '../../helpers/not-null.helper';
import { StepIndicatorItemComponent } from '../step-indicator-item/step-indicator-item.component';
import { StepIndicatorComponent } from '../step-indicator/step-indicator.component';

@Component({
    selector: 'tm-step-indicator-step-button',
    templateUrl: 'step-indicator-step-button.component.html',
    standalone: false
})
export class StepIndicatorStepButtonComponent {
    @Input()
    public get item(): StepIndicatorItemComponent {
        return notNull(this._item, 'item');
    }
    public set item(value: StepIndicatorItemComponent) {
        this._item = value;
    }
    private _item: StepIndicatorItemComponent;
    @HostBinding('class.o-step-indicator-step-button')
    public stepIndicatorStepButton = true;

    constructor(private _stepIndicator: StepIndicatorComponent) {}

    public select(): void {
        this._stepIndicator.select(this.item);
    }
}
